import { _ } from '@portal-internet/core';

const getDefaultBreakpoints = () => ({
    600: {
        slidesPerView: 2,
        spaceBetween: 12,
        slidesPerGroup: 2
    },
    720: {
        slidesPerView: 3,
        spaceBetween: 16,
        slidesPerGroup: 3
    },
    1024: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup: 4
    },
    1920: {
        slidesPerView: 5,
        spaceBetween: 16,
        slidesPerGroup: 5
    }
});

const getBreakpointsForButlletins = () => ({
    320: {
        slidesPerView: 1.1,
        spaceBetween: 16,
        slidesPerGroup: 1
    },
    744: {
        slidesPerView: 2,
        spaceBetween: 24,
        slidesPerGroup: 2
    },
    1024: {
        slidesPerView: 2.5,
        spaceBetween: 24,
        slidesPerGroup: 2.5
    },
    1303: {
        slidesPerView: 3,
        spaceBetween: 24,
        slidesPerGroup: 3
    },
    1920: {
        slidesPerView: 3,
        spaceBetween: 24,
        slidesPerGroup: 3
    },
    2180: {
        slidesPerView: 4,
        spaceBetween: 24,
        slidesPerGroup: 4
    }
});

const getBreakpointsFor8col = () => ({
    320: {
        slidesPerView: 1.5,
        spaceBetween: 16,
        slidesPerGroup: 1
    },
    600: {
        slidesPerView: 2,
        spaceBetween: 12,
        slidesPerGroup: 2
    },
    720: {
        slidesPerView: 2.4,
        spaceBetween: 16,
        slidesPerGroup: 2
    },
    1024: {
        slidesPerView: 3.5,
        spaceBetween: 16,
        slidesPerGroup: 3
    },

    2180: {
        slidesPerView: 4,
        spaceBetween: 24,
        slidesPerGroup: 4
    }
});

const getPropsSwiper = (format, col) => {
    let breakpoints = getDefaultBreakpoints();

    switch (format) {
        case 'col12':
        case 'butlletins':
            breakpoints = getBreakpointsForButlletins();
            break;
        case 'col8':
            breakpoints = getBreakpointsFor8col();
            break;
        default:
            break;
    }

    return {
        spaceBetween: 12,
        slidesPerView: 1.3,
        slidesPerGroup: 1,
        freeMode: true,
        watchSlidesProgress: true,
        simulateTouch: false,
        breakpoints: breakpoints
    };
};

export { getPropsSwiper };
